import {makeStyles} from "tss-react/mui";

export const useChipStyles = makeStyles()(
  (theme, {background, foreground, margin, clickable, fullWidth, isListItem} = {}) => ({
    styledChip: {
      backgroundColor: background || theme.palette.grey.light,
      color: foreground || theme.palette.grey.contrastText,
      maxWidth: "100%",
      margin,
      cursor: clickable ? "pointer" : "inherit",
      width: fullWidth ? "100%" : "auto",
    },
    activeStateChip: {
      backgroundColor: "green",
      color: theme.palette.primary.contrastText,
    },
    avatarTextChip: {
      background: "inherit",
      color: isListItem ? theme.palette.text.primary : "inherit",
      fontSize: isListItem ? "1rem" : "inherit !important",
      "&>.MuiChip-labelSmall": {
        paddingLeft: theme.spacing(1),
      },
      "&>.MuiChip-label": {
        marginLeft: isListItem ? theme.spacing(0.5) : undefined,
      },
    },
    selectTagWrapped: {
      height: "auto",
      maxWidth: "100%",
      minWidth: 0,
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      "& span": {
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    },
  }),
);
